import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { StudentGroupSelectionRepositoryService } from '../../services/student-group-selection-repository.service';
import { StudentGroupSelectComponent } from '../student-group-select/student-group-select.component';

@Component({
  selector: 'app-student-group-multi-select',
  templateUrl: './student-group-multi-select.component.html',
  styleUrls: [
    '../student-group-select/student-group-select.component.scss',
    './student-group-multi-select.component.scss'
  ],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => StudentGroupMultiSelectComponent),
    multi: true
  }]
})
export class StudentGroupMultiSelectComponent extends StudentGroupSelectComponent {
  readonly multiSelectPanelStyle: { [key: string]: string } = { 'z-index': '1030' };

  constructor(repository: StudentGroupSelectionRepositoryService) {
    super(repository);
  }
}
